
import './App.css';

import React, { useState } from 'react';
import IndexRoute from './PageComponents/IndexRoute.js';
import './assets/images/scss/themes.scss';
import LoaderMainPage from './PageComponents/Loader/LoaderMainPage';

function App() {
  const [loading, setLoading] = useState(true);
  return (
    <React.Fragment>
       {loading ? <LoaderMainPage onFinish={() => setLoading(false)} /> :  <IndexRoute/>}

      </React.Fragment>
  );
}

export default App;
